import React from 'react';
import { 
  Box, 
  Typography, 
  Grid, 
  Divider, 
  IconButton,
  Stack,
  useTheme
} from '@mui/material';
import { 
  Facebook, 
  Twitter, 
  LinkedIn, 
  Instagram,
  YouTube
} from '@mui/icons-material';
import { FooterCategories } from '../constants/menu-items';
import { ManualItem } from '../types';

interface FooterProps {
  manualItems: ManualItem[];
}

const Footer = ({ manualItems }: FooterProps) => {

  const theme = useTheme();
  
  const getItemsByFooter = (footer: string) => {
    return manualItems
      .filter(item => item.locations?.footer?.section === footer)
      .map(item => ({
        name: item.name,
        url: item.type === 'file' ? item.fileUrl : item.externalUrl
      }));
  };

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: theme.palette.primary.main,
        color: '#ffffff',
        padding: { xs: '2rem 1rem', md: '3rem 2rem' },
        marginTop: 'auto'
      }}
    >
      <Grid 
        container 
        spacing={4} 
        justifyContent="space-between"
        maxWidth="1200px"
        margin="0 auto"
      >
        <Grid item xs={12} md={4}>
          <Typography 
            variant="h6" 
            gutterBottom 
            sx={{ 
              fontWeight: 'bold',
              color: '#ffffff'
            }}
          >
            Nosotros
          </Typography>
          <Typography variant="body1" paragraph sx={{ color: '#ffffff' }}>
            Creamos el Software de Gestión ERP más potente pensado para empresas del sector construcción e inmobiliario
          </Typography>
          
          <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
            <IconButton aria-label="Facebook" sx={{ color: '#ffffff' }}>
              <Facebook />
            </IconButton>
            <IconButton aria-label="Twitter" sx={{ color: '#ffffff' }}>
              <Twitter />
            </IconButton>
            <IconButton aria-label="LinkedIn" sx={{ color: '#ffffff' }}>
              <LinkedIn />
            </IconButton>
            <IconButton aria-label="Instagram" sx={{ color: '#ffffff' }}>
              <Instagram />
            </IconButton>
            <IconButton aria-label="YouTube" sx={{ color: '#ffffff' }}>
              <YouTube />
            </IconButton>
          </Stack>
        </Grid>
        {FooterCategories.map((category) => (
          <Grid item xs={6} sm={4} md={2} key={category.title}>
            <Typography 
              variant="h6" 
              gutterBottom 
              sx={{ 
                fontWeight: 'bold',
                color: '#ffffff'
              }}
            >
              {category.title}
            </Typography>
            <Box component="ul" sx={{ listStyle: 'none', pl: 0 }}>
              {getItemsByFooter(category.title).map((item) => (
                <Typography 
                  component="li" 
                  key={item.name} 
                  sx={{ 
                    py: 0.5,
                    color: '#ffffff',
                    '&:hover': { color: '#ffc107' }
                  }}
                >
                  {item.name}
                </Typography>
              ))}
            </Box>
          </Grid>
        ))}

      </Grid>

      <Divider sx={{ 
        my: 4, 
        backgroundColor: 'rgba(255, 255, 255, 0.1)' 
      }} />

      <Typography 
        variant="body2" 
        align="center"
        sx={{ 
          color: '#bdbdbd',
          fontSize: '0.875rem'
        }}
      >
        ©{new Date().getFullYear()} Todos los derechos Reservados por S10 Perú
      </Typography>
    </Box>
  );
};

export default Footer;